import React, { useState } from 'react';
import axios from 'axios';
import config from '../../../../config/environment';
import CheckAuth from '../../elements/checkAuth';
import Menu from '../../elements/Menu/menu';
import './cardInfo.css'


let TableComponent = (props) => {
    const { data } = props
    let bufMap = []

    bufMap = data.cardOrdersData.map((elem) => {
        let tmpObj = {}
        for (let key in elem) {
            if (key === 'createdAt') {
                tmpObj[key] = elem[key].substring(0, 10) + ' ' + elem[key].substring(11, 19)
            } else if (key === 'userData') {
                if (elem[key].cashbackLabel) {
                    tmpObj.cashbackToken = elem[key].cashbackToken + " (" + elem[key].cashbackLabel + ")"
                } else {
                    tmpObj.cashbackToken = elem[key].cashbackToken
                }
            } else {
                tmpObj[key] = elem[key]
            }
        }
        return tmpObj
    });

    let constructHeader = () => {
        let header = []
        for (let key in bufMap[0]) {
            header.push(
                <th>
                    {key}
                </th>
            )
        }
        return header
    }

    return (
        <>
            <table className="CI_table table tableInfoAddress">
                <thead>
                    <tr>
                        {
                            constructHeader()
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        bufMap.map(el => {
                            let header = []
                            for (let key in el) {
                                header.push(
                                    <td>
                                        {el[key]}
                                    </td>
                                )
                            }

                            return (
                                <tr>
                                    {header}
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </>
    )
};


export default function CardInfo() {
    const [inputState, setInputState] = useState({
        inputData: '',
        querryError: null,
        resp: null,
        showTable: false
    });

    const handleInpput = (event) => {
        setInputState({
            ...inputState,
            inputData: event.target.value,
            querryError: null
        })
    }

    const handleSubmit = async () => {
        let querry = config.backendUrl + "/payment-details/get-card-info?paymentDetails=" + inputState.inputData
        await axios.get(querry, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            }
        }).then(
            (resp) => {
                setInputState({
                    ...inputState,
                    querryError: null,
                    resp: resp.data,
                    showTable: true
                })
            }
        ).catch((error) => {
            setInputState({
                ...inputState,
                querryError: error.response.data.message || error.message,
                resp: null,
                showTable: false
            })
        })
    }

    return (
        <>
            <CheckAuth />
            <Menu />
            <div className="CI_main_wrapper">
                <div className="CI_input_wrapper">
                    <div>
                        <input type="text" className="CI_input" value={inputState.inputData} onChange={handleInpput} placeholder='Card' />
                        <button onClick={handleSubmit} className="CI_input_button">GET</button>
                    </div>
                    {
                        inputState.querryError ? <div className="CI_querry_error">{inputState.querryError}</div> : null
                    }
                </div>
                {
                    inputState.showTable ? <div className="CI_table_wrap"><TableComponent data={inputState.resp} /></div> : null
                }
            </div>
        </>
    );
};
